<template>
  <div class="my-vacancy-card"
       :class="{ '_extended': extended, '_hidden': !vacancy.is_show }"
       @click="click">
    <BasePreloader v-if="pending"/>

    <div class="my-vacancy-card__main">
      <div class="my-vacancy-card__image-wrap">
        <FileShow v-if="$get(vacancy.images, 'length')"
                  :value="vacancy.images[0]"
                  only-show
                  class="my-vacancy-card__img  _cover"/>
        <div v-else
             class="my-vacancy-card__img  _placeholder"></div>

        <transition name="fade">
          <div v-if="extended"
               class="my-vacancy-card__image-overlay-card">
            <div class="my-vacancy-card__image-overlay-data-row  _id">
              <span>ID:{{ vacancy.id }}</span>
            </div>
            <div class="my-vacancy-card__image-overlay-data-row">
              <BaseSvg name="ico-calendar"/>
              <span>{{ $tEmployerVacancies('published_date') }}:</span>
              <time :datetime="vacancy.created_at">{{ vacancy.created_at | formatDateAs('dd MMMM') }}</time>
            </div>
            <div class="my-vacancy-card__image-overlay-data-row">
              <BaseSvg name="ico-calendar"/>
              <span>{{ $tEmployerVacancies('relevant_until_date') }}:</span>
              <time :datetime="vacancy.relevant_until">{{ vacancy.relevant_until | formatDateAs('dd MMMM') }}</time>
            </div>
          </div>
        </transition>

        <div v-if="vacancy.hot" class="my-vacancy-card__hot-sign">
          <BaseSvg name="ico-fire" width="1.5rem" height="2rem"/>
        </div>
      </div>

      <div class="my-vacancy-card__content-wrap">
        <div class="my-vacancy-card__title-wrap">
          <div>
            <router-link-modified
              class="my-vacancy-card__title"
              :to="vacancyRoutePath"
              @click.stop=""
            >
              {{ vacancyTitle }}
            </router-link-modified>
            <span v-if="!vacancy.is_show" class="my-vacancy-card__hidden-alert">
              <BaseSvg name="ico-strikethrough-circle" width="1.5rem" height="1.5rem" />
              <span class="ml-2">{{ $tEmployerVacancies('Hidden') }}</span>
            </span>
          </div>
          <div v-if="!moderatorVerifiedProfile" class="d-flex mt-2">
            <div v-if="!moderatorVerifiedProfile" class="my-vacancy-card__no-display-alert">{{ $tEmployerVacancies('Vacancy unavailable for display') }}</div>
          </div>
        </div>

        <div class="my-vacancy-card__analytics">
          <div class="my-vacancy-card__analytics-row">
            <div>
              <BaseSvg name="ico-user-check"
                       width="1.4rem"
                       height="1.3rem"/>
              {{ $tEmployerVacancies('statistic_responded') }}:
            </div>
            <div>{{ vacancy.resume_count || 0 }}</div>
          </div>
          <div class="my-vacancy-card__analytics-row">
            <div>
              <BaseSvg name="ico-eye-filled"
                       width="1.4rem"
                       height="1.4rem"/>
              {{ $tEmployerVacancies('statistic_views') }}:
            </div>
            <div>{{ vacancy.views || 0 }}</div>
          </div>
          <div class="my-vacancy-card__analytics-row">
            <div>
              <BaseSvg name="ico-group"
                       width="1.4rem"
                       height="1.4rem"
                       style="top: -0.1rem"/>
              {{ $tEmployerVacancies('statistic_places') }}:
            </div>
            <div>{{ vacancy.occupied_places }}</div>
          </div>
        </div>
        <div class="my-vacancy-card__show-resumes">
          <button
              class="my-vacancy-card__show-resumes-btn base-btn base-btn--green"
              :disabled="!vacancy.resume_count"
              @click.stop.prevent="findReceivedResumes(vacancy.id)"
          >
            {{ $tEmployerVacancies('received_resumes_btn') }}
          </button>
          <button
              class="my-vacancy-card__extend-card-btn"
              @click.stop="toggleExtended"
          >
            <BaseSvg name="ico-triangle-down" width="1.8rem" height="1.2rem"/>
          </button>
        </div>
      </div>
    </div>

    <CollapseTransition>
      <div v-if="extended"
           class="my-vacancy-card__extension-wrap">
        <div
            class="my-vacancy-card__extension">
          <div class="my-vacancy-card__extension-promotions">
            <div class="my-vacancy-card__extension-promotion">
              <button
                  class="my-vacancy-card__extension-promotion-btn base-btn base-btn--blue"
                  @click.stop.prevent="onToggleHot(vacancy.id)"
              >
                <span>{{ $tEmployerVacancies(vacancy.hot ? 'make_not_hot_btn' : 'make_hot_btn') }}</span>
              </button>
              <div class="my-vacancy-card__extension-promotion-text">
                <div>{{ $tEmployerVacancies('remains_hot') }}: {{ vacancy.hot_count }}</div>
              </div>
            </div>
            <div class="my-vacancy-card__extension-promotion">
              <button
                  class="my-vacancy-card__extension-promotion-btn base-btn base-btn--blue"
                  @click.stop.prevent="onUp(vacancy.id)"
              >
                {{ $tEmployerVacancies('up_btn') }}
              </button>
              <div class="my-vacancy-card__extension-promotion-text">
                <div style="margin-bottom: 0.2rem">{{ $tEmployerVacancies('lifting_remains') }}: {{ vacancy.bumps_count }}</div>
                <div class="d-flex">
                  <div>{{ $tEmployerVacancies('current_position_in_catalog') }}:&nbsp;</div>
                  <div class="my-vacancy-card__extension-promotion-count relative d-flex">
                    <BasePreloader v-if="loading.currentCatalogPosition" />
                    <div v-else>{{ currentCatalogPosition }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="my-vacancy-card__extension-actions">
            <router-link-modified
                class="my-vacancy-card__extension-action"
                :to="{ name: 'account-new-vacancy', query: { vacancy: vacancy.id } }"
                @click.stop="">
              <BaseSvg name="ico-pencil-filled" width="1.3rem" height="1.3rem"/>
              {{ $tEmployerVacancies('edit_btn') }}
            </router-link-modified>
            <button class="my-vacancy-card__extension-action  inline-link"
                    @click.stop.prevent="vacancy.show ? onHide(vacancy.id) : onShow(vacancy.id)">
              <BaseSvg v-if="vacancy.show"
                       name="ico-eye-hide"
                       width="1.7rem"
                       height="1.3rem"
                       style="top: 0.2rem"/>
              <BaseSvg v-else
                       name="ico-eye-filled"
                       width="1.7rem"
                       height="1.3rem"
                       style="top: 0.1rem"/>
              <span>{{ $tEmployerVacancies(vacancy.show ? 'hide_btn' : 'show_btn') }}</span>
            </button>
            <router-link-modified
              class="my-vacancy-card__extension-action"
              :to="{ name: 'account-new-vacancy', query: { duplicate: vacancy.id } }"
              @click.stop=""
            >
              <BaseSvg name="ico-notes-add"
                       width="1.6rem"
                       height="1.4rem"
                       style="top: 0.1rem"/>
              <span>{{ $tEmployerVacancies('duplicate_vacancy_btn') }}</span>
            </router-link-modified>
            <button class="my-vacancy-card__extension-action  _delete   base-btn  base-btn--blue"
                    @click.stop.prevent="onDelete(vacancy.id)">
              <BaseSvg name="ico-trash-outlined" width="1.5rem" height="1.7rem"/>
            </button>
          </div>
        </div>
      </div>
    </CollapseTransition>
  </div>
</template>

<script>
  import {http} from "@/axios"
  import {mapGetters, mapActions} from 'vuex';
  import {CollapseTransition} from 'vue2-transitions';
  import windowSizeMixin from '../mixins/windowSizeMixin';
  import FileShow from '@/components/FileShow'

  export default {
    name: "MyVacancyCard",
    components: {
      CollapseTransition,
      FileShow
    },
    mixins: [windowSizeMixin],
    props: {
      vacancy: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        isMenuOpen: false,
        extended: false,
        pending: false,
        currentCatalogPosition: '-',

        loading: {
          currentCatalogPosition: false,
        },
      }
    },
    computed: {
      ...mapGetters('user', [
        'moderatorVerifiedProfile',
      ]),
      vacancyRoutePath() {
        return {
          name: 'vacancy',
          params: {
            vacancyId: this.vacancy.slug,
            directionId: this.vacancy.category && (this.vacancy.category.direction_slug || this.vacancy.category.direction_id) || 'no-direction'
          }
        };
      },
      currentCurrency() {
        let currentCurrency = this.$store.state.currentCurrency
        if (currentCurrency.currency === 'ALL') {
          currentCurrency = this.vacancy.currency
        }

        return currentCurrency
      },
      filterQueryParamsNames() {
        return this.$store.state.filter.queryParamsNames
      },
      vacancyTitle() {
        const title = this.vacancy.title;
        if (title?.length > 100) return title.slice(0, 97) + '...';
        return title;
      },
    },
    methods: {
      ...mapActions('vacancies', [
        'getVacancyPosition',
      ]),
      ...mapActions('helpers', [
        'canDoAction',
      ]),

      click() {
        if (this.windowSizeMixin.width > process.env.VUE_APP_WINDOW_SIZE_SM) {
          this.toggleExtended();
        } else this.$router.push(this.vacancyRoutePath);
      },
      toggleExtended() {
        this.extended = !this.extended;

        if (this.extended) {
          this.loadCurrentCatalogPosition();
        }
      },
      async loadCurrentCatalogPosition() {
        this.loading.currentCatalogPosition = true;

        this.currentCatalogPosition = await this.getVacancyPosition({ vacancyId: this.vacancy.id })
          .catch(() => {})
          .finally(() => this.loading.currentCatalogPosition = false);
      },
      getCurrencyById(id) {
        let currency = this.$store.state.currencies.find(c => c.id === id)
        return currency ? currency.currency : null
      },
      onDelete(vacancyId) {
        this.$vModal.open('confirm', {
          title: this.$tEmployerVacancies('delete_vacancy_confirm_title'),
          onAccept: () => {
            this.pending = true

            return http.delete(`/api/vacancy/${vacancyId}`).then(() => {
              this.$vModal.close('confirm')
            }).finally(() => {
              this.pending = false
              this.$emit('reload')
            })
          }
        })
      },
      onHide(vacancyId) {
        this.pending = true

        return http.post(`/api/cabinet/vacancy/${vacancyId}/hide`).then(() => {
        }).finally(() => {
          this.pending = false
          this.$emit('reload')
        })
      },
      onShow(vacancyId) {
        this.pending = true

        return http.post(`/api/cabinet/vacancy/${vacancyId}/show`).then(() => {
          this.$emit('show', vacancyId);
        }).finally(() => {
          this.pending = false
          this.$emit('reload')
        })
      },
      async onToggleHot(vacancyId) {
        const canDoActionData = await this.canDoAction({ action: 'action_hots' });
        const isHot = this.vacancy.hot;
        const title = canDoActionData.popup?.title
          || this.$tEmployerVacancies(isHot ? 'make_not_hot_dialog_title' : 'make_hot_dialog_title');
        const message = canDoActionData.popup?.text
          || this.$tEmployerVacancies(isHot ? 'make_not_hot_dialog_description' : 'make_hot_dialog_description');

        this.$vModal.open('confirm', {
          title,
          message,
          successBtnClass: 'base-btn--outline-blue',
          onSuccess: () => {
            this.toggleHot(vacancyId);
          },
        });
      },
      toggleHot(vacancyId) {
        this.pending = true

        http.post(`/api/cabinet/vacancy/${vacancyId}/hot`)
            .finally(() => {
              this.pending = false
              this.$emit('reload')
            })
      },

      onActivate(vacancyId) {
        this.pending = true

        return http.post(`/api/cabinet/vacancy/${vacancyId}/set-active`).then(() => {
        }).finally(() => {
          this.pending = false
          this.$emit('reload')
        })
      },
      async onUp(vacancyId) {
        const canDoActionData = await this.canDoAction({ action: 'action_bumps' });

        this.$vModal.open('confirm', {
          title: canDoActionData.popup?.title || this.$tEmployerVacancies('up_vacancy_confirm_title'),
          message: canDoActionData.popup?.text || this.$tEmployerVacancies('up_vacancy_confirm_description'),
          successBtnClass: 'base-btn--outline-blue',
          onSuccess: () => {
            this.upVacancy(vacancyId);
          },
        });
      },
      upVacancy(vacancyId) {
        this.pending = true

        return http.post(`/api/new-vacancy/${vacancyId}/bump`).then(() => {
        }).finally(() => {
          this.pending = false
          this.$emit('reload')
        })
      },
      findReceivedResumes(vacancyId) {
        this.$router.push({name: 'account-vacancies-responses', query: {'vacancy_id': vacancyId}})
      }
    },
  }
</script>
